import { atom } from 'jotai';

export const fundWalletPopupState = atom<{
    currencyCode?: string;
    walletId?: string;
    // We have to pass a fallback `companyId` for a situations, when user from pages such as "Ready to pay"
    companyId?: string;
}>({});
